/**
 * Member portal auth context — delegates to the shared AuthProvider.
 *
 * With Managed Login, all authentication flows (email/password, Google,
 * password reset, force-change-password) are handled by Cognito's hosted UI.
 * This file configures the shared provider with member-portal-specific settings.
 */

import { ReactNode } from 'react'
import { AuthProvider as SharedAuthProvider, useAuth, type AuthProviderConfig } from '@brent/shared'
import type { User } from '@brent/shared'

export type { User }
export { useAuth }

// Re-export the context type for consumers that need it
export type { AuthContextType } from '@brent/shared'

const memberConfig: AuthProviderConfig = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  region: import.meta.env.VITE_COGNITO_REGION || 'eu-west-1',
  domain: import.meta.env.VITE_COGNITO_DOMAIN,
  redirectUri: `${window.location.origin}/auth/callback`,
  logoutUri: window.location.origin,
}

interface AuthProviderProps {
  children: ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  return <SharedAuthProvider config={memberConfig}>{children}</SharedAuthProvider>
}
